import { useMemo } from "react";
import _ from "lodash";

export const useYearsCleaner = (
    years: number[],
    linesData: number[][],
    providerMedianData: number[][]
): {
    years: number[];
    linesData: number[][];
    providerMedianData: number[][];
} => {
    return useMemo(() => {
        // find the point where linesData turns from null to number

        const linesDataStartEndYear = [
            ...(linesData ?? ([] as number[][]))
            // ...(providerMedianData ?? ([] as number[][]))
        ]?.map(lineData => {
            const hasData = lineData?.find(d => d != null) != null;

            const _years = [];
            const trailedYears = [];
            const invertedYears = _.reverse(_years);

            lineData.forEach((d, index) => {
                if (index === 0) {
                    if (d == null) {
                        _years.push(years[index]);
                    }
                } else {
                    if (_years[index - 1] != null && d == null) {
                        _years.push(years[index]);
                    }
                }
            });

            _.reverse([...(lineData ?? ([] as number[]))]).forEach((d, index) => {
                if (index === 0) {
                    if (d == null) {
                        trailedYears.push(invertedYears[index]);
                    }
                } else {
                    if (trailedYears[index - 1] != null && d == null) {
                        trailedYears.push(invertedYears[index]);
                    }
                }
            });

            return {
                start: _.max(_years) ?? (hasData ? _.min(years) - 1 : undefined),
                end: _.min(trailedYears) ?? (hasData ? _.max(years) + 1 : undefined)
            };
        });

        const start = _.min(linesDataStartEndYear.map(d => d.start));
        const end = _.max(linesDataStartEndYear.map(d => d.end));

        const filteredYears = years?.filter(d => (start == null || d > start) && (end == null || d < end));
        const mask = years?.map(d => ((start == null || d > start) && (end == null || d < end) ? true : false));

        const filteredLinesData = linesData.map(lineData => {
            return lineData.filter((d, index) => {
                return mask[index] === true;
            });
        });

        const filteredProviderMedianData = providerMedianData.map(lineData => {
            return lineData.filter((d, index) => {
                return mask[index] === true;
            });
        });

        return { years: filteredYears, linesData: filteredLinesData, providerMedianData: filteredProviderMedianData };
    }, [years, linesData, providerMedianData]);
};
